import { Content_Block } from "../ContentBlock";

export class ImageBlock extends Content_Block{
    constructor(){
        super("image");
        this.url = "";
        this.alignement = "center";
        this.largeur = 50;
    }
}